(ns frontend.view.modals.team-edit.view
    (:require
      [common.localization :as loc]
      [common.modules :as modules]
      [frontend.db :as main-db]
      [frontend.state.current-session :as session]
      [frontend.utils :as fu]
      [frontend.view.components.module-selector :as module-selector]
      [frontend.view.modals.components.processing-modal :as processing-modal]
      [frontend.view.modals.team-edit.events :as events]
      [ui.components.input.checkbox :as checkbox]
      [ui.components.modal.view :as modal]
      [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :team-edit-modal)

(defn not-unique-team?
  [existing-teams team-id team-name]
  (let [lc (fu/trimmed-lower-case team-name)]
    (contains? (->> existing-teams
                    (remove (fn [t]
                              (= (:db/id t) team-id)))
                    (map :team/name)
                    (map fu/trimmed-lower-case)
                    (set))
               lc)))

(defn view-body
  [state existing-teams modules _team-id]
  (let [tenant-modules (->> (modules/all-modules @main-db/tenant @session/tenant-plan)
                            (filter @main-db/tenant-modules))
        export-denied? (:team/deny-export-access @state)
        read-only? (:team/read-only-team? @state)]
    [:div
     {:class "flex flex-col gap-4"}
     [:div
      [labelled-input/view
       {:label     (loc/tr :team/name)
        :data-type :data.type/text-simple
        :value     (get @state :team/name)
        :on-change (fn [new-value]
                     (swap! state assoc :team/name new-value))}]
      [:p {:class "text-xs"}
       (cond (not-unique-team? existing-teams (:db/id @state) (:team/name @state))
             (loc/tr :this-team-already-exists)
             (empty? (:team/name @state))
             (loc/tr :error-field-not-clearable [(loc/tr :team/name)]))]]

     [:div
      [module-selector/view
       {:label     (loc/tr :modules/access-to-modules)
        :value     (set modules)
        :values    tenant-modules
        :edit?     true
        :on-change (partial events/modify-modules! state :team/modules)}]]

     [:<>
      [:div
       {:class "flex flex-col gap-2"}
       [:label
        {:class "font-bold"}
        (loc/tr :team-export-access)]
       [:label
        {:class "flex gap-3 cursor-pointer"}
        [checkbox/view
         {:value     (boolean export-denied?)
          :on-change (fn [_e]
                       (swap! state update :team/deny-export-access not))}]
        [:span
         (loc/tr :yes)]]]

      (when (session/has-feature-access? :feature/read-only-teams)
        [:div
         {:class "flex flex-col gap-2"}
         [:label
          {:class "font-bold"}
          (loc/tr :team-read-only-access)]
         [:label
          {:class "flex gap-3 cursor-pointer"}
          [checkbox/view
           {:value     read-only?
            :on-change (fn [_e]
                         (swap! state update :team/read-only-team? not))}]
          [:span
           (loc/tr :yes)]]])]]))

(defn footer-view
  [state duplicate-name?]
  [modal/right-single-button
   nil
   (or duplicate-name?
       (not (events/form-ready? state))
       (events/no-changes? state))
   #(events/save! state)
   (loc/tr :save)
   nil])

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [existing-teams team-id on-close!]} props
        on-close! (fn []
                    (close-modal!)
                    (when on-close!
                      (on-close!)))
        modules (-> @state
                    :team/modules)]
    [processing-modal/render-modal
     {:state             state
      :shown?            (and shown? topmost?)
      :success-text      (loc/tr :success-team-updated-or-created)
      :on-close!         on-close!
      :class-name        class-name
      :on-show!          (fn []
                           (reset! state (get @session/entities team-id)))
      :default-title-fn  #(loc/tr :team-edit-modal/title)
      :default-body-fn   (partial view-body state existing-teams modules team-id)
      :default-footer-fn (partial
                           footer-view
                           state
                           (not-unique-team? existing-teams (:db/id @state) (:team/name @state)))}]))
